import React from 'react';
import { styled } from 'linaria/react';
import { Above } from '@jetshop/ui/Breakpoints';

const SpacerWrapper = styled('div')`
  width: 100%;
  height: ${(props) => props.spacerheight}rem;
`;

export const Spacer = ({ height }) => {
  let selectedSpace = 2;
  switch (height?.value) {
    case 'XSMALL':
      selectedSpace = 0.5;
      break;
    case 'SMALL':
      selectedSpace = 1;
      break;
    case 'MEDIUM':
      selectedSpace = 3;
      break;
    case 'LARGE':
      selectedSpace = 6;
      break;
    case 'XLARGE':
      selectedSpace = 8;
      break;
    default:
      selectedSpace = 4;
      break;
  }
  return (
    <Above breakpoint="lg">
      {(matches) =>
        matches ? (
          <SpacerWrapper spacerheight={selectedSpace} />
        ) : (
          <SpacerWrapper spacerheight={selectedSpace * 0.8} />
        )
      }
    </Above>
  );
};
